import axios, { AxiosError, AxiosResponse } from "axios";

const NOT_AUTHENTICATED_MESSAGES = [
    "Authentication token is missing",
    "Invalid token or user no longer exists",
    "Invalid or expired token",
];

// Variables to store token and user ID
let authToken = "";
let userId = "";

// Function to set the authentication token and user ID
export const setAuthCredentials = (token: string, id: string) => {
    authToken = token;
    userId = id;
};

export const setAuthToken = (token: string) => {
    authToken = token;
};

// Create an Axios instance
const apiClient = axios.create({
    baseURL: process.env.REACT_APP_CLOUD_API_BASE_URL, // Your API's base URL
    headers: {
        "Content-Type": "application/json",
    },
});

// Setup request interceptor to add user ID and auth token
apiClient.interceptors.request.use(
    (config) => {
        if (authToken && userId) {
            // Set the Authorization header with the token
            // eslint-disable-next-line no-param-reassign
            config.headers.Authorization = `Bearer ${authToken}`;
            // Optionally, include user id in headers or elsewhere in your requests
            // eslint-disable-next-line no-param-reassign
            config.headers["X-User-ID"] = userId;
        }
        return config;
    },
    (error) => Promise.reject(error),
);

// Setup response interceptor for error handling (503 and other status codes)
apiClient.interceptors.response.use(
    (response: AxiosResponse) => {
        // If the response is successful, just return it
        return response;
    },
    (error: AxiosError) => {
        // Check if the error response status is 503
        if (error.response) {
            if (error.response.status === 503) {
                // Redirect to the maintenance page
                window.location.href = "/maintenance"; // Redirects to the MaintenancePage
            } else if ((error.response.status === 401)
                // @ts-expect-error TS2339
                && NOT_AUTHENTICATED_MESSAGES.includes(error.response?.data?.message)) {
                // Store the current page in localStorage before redirecting
                const currentPath = window.location.pathname + window.location.search;
                localStorage.setItem("redirectAfterSignIn", currentPath);

                window.location.href = "/auth/sign-in"; // Redirect to the SignInPage
            }
        } else if (error.code === "ERR_NETWORK") {
            console.error("Connection refused error. Please check the server or your network connection.");
            alert("Unable to connect to the server. Please check your connection or try again later.");
        } else if (error.code === "ECONNABORTED") {
            console.error("Request timeout. Please try again later.");
            alert("The request took too long. Please try again later.");
        }
        // Handle other errors or rethrow them
        return Promise.reject(error);
    },
);

export default apiClient;
